<template>
  <component :is="componentCard" class="offer-card" :cardNumber="cardNumber" />
</template>

<script lang="ts">
import { defineComponent, computed, defineAsyncComponent } from "vue";
import {
  BILLBOARD,
  injectTemplateSize,
  LARGE_RESPONSIVE,
  MOBILE_LEADERBOARD,
  LEADERBOARD,
  LARGE_LEADERBOARD,
  MPU,
  LARGE_MPU,
  SKYSCRAPER,
  LMLB,
  TemplateSizeContext
} from "@fresh8/ad-data-composition/src/useTemplateSize";
import LeaderboardOffer from "./LeaderboardOffer.vue";
import MPUOffer from "./MPUOffer.vue";
import LargeMPUOffer from "./LargeMPUOffer.vue";
import MobileLeaderboardOffer from "./MobileLeaderboardOffer.vue";
import LMLBOffer from "./LMLB_Offer.vue";
import SkyscraperOffer from "./SkyscraperOffer.vue";
import WideOffer from "./WideOffer.vue";

export default defineComponent({
  name: "OfferWrapper",
  props: {
    marketId: { type: String, required: true },
    eventId: { type: String, required: true },
    cardNumber: { type: String, required: false, default: "1" }
  },
  setup() {
    const template = injectTemplateSize() as TemplateSizeContext;

    const componentCard = computed(() => {
      switch (template.size.value.name) {
        case LEADERBOARD.name:
        case LARGE_LEADERBOARD.name:
          return LeaderboardOffer;
        case LARGE_MPU.name:
          return LargeMPUOffer;
        case MPU.name:
        case BILLBOARD.name:
        case LARGE_RESPONSIVE.name:
          return MPUOffer;
        case MOBILE_LEADERBOARD.name:
          return MobileLeaderboardOffer;
        case LMLB.name:
          return LMLBOffer;
        case SKYSCRAPER.name:
          return SkyscraperOffer;
        default:
          return WideOffer;
      }
    });

    return {
      componentCard
    };
  }
});
</script>
